import type { ThunkAction } from "redux-thunk";
import type { RootState } from "~/redux/store";
import type { AnyAction } from "~/redux/types";
import { apiUpdateColumnSettings } from "~/Search/components/ProductResults/views/NewTabularView/ConfigureColumnsButton/apiUpdateColumnSettings";
import { updateColumnVisibilityAction } from "~/Search/redux/actions";

export function updateColumnVisibilityThunk(
  columnVisibility: { code: string; visible: boolean }[],
  isReset = false,
): ThunkAction<void, RootState, undefined, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();
    const unitMode = state.userPreferences.unitMode;
    dispatch(updateColumnVisibilityAction(columnVisibility, unitMode));
    apiUpdateColumnSettings(columnVisibility, isReset);
  };
}
